import { DataBean } from "../../DataBean";


export class GetHandleTypes extends DataBean {

    public async getHandleTypes(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHandleTypes_Number", [args]);
    }

}